import {css, getSimilarColor} from '../utils.js';

const styles = css`
    .ddk-container .layout-hero-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: ${props => props.theme.hero_padding ?? '24px'};
        background: ${props =>
            props.theme.hero_background_color ??
            'var(--ddk-surface-surface-tertiary, #DDD)'};
        border-top: ${props => {
            const border = props.theme.hero_border;
            return border
                ? `${border.width} ${border.style} ${border.color}`
                : 'none';
        }};
    }

    .ddk-container .layout-hero-container .hero-content {
        display: flex;
        flex-direction: column;
        height: 100%;
        width: 100%;
        gap: ${props => props.theme.hero_gap ?? '24px'};
    }

    .ddk-container .layout-hero-container .hero-content .hero-stack {
        display: flex;
        align-items: center;
        gap: var(--ddk-spacing-space-2, 16px);
        align-self: stretch;
    }

    .ddk-container .hero-info-cta {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: var(--ddk-spacing-space-2, 16px);
        flex: 1 0 0;
    }

    .ddk-container .hero-info {
        display: flex;
        flex-direction: column;
        gap: ${props => props.theme.hero_gap ?? '16px'};
        max-width: 840px;
    }

    .ddk-container .hero-info h1.hero-title {
        color: ${props =>
            props.theme.hero_title_text ?? 'var(--ddk-text-base-primary)'};
        font-family: ${props => props.theme.font_family_header ?? 'Inter'};
        font-size: ${props => props.theme.hero_title_font_size ?? '48px'};
        font-style: normal;
        font-weight: 400;
        line-height: 125%;
        margin: 0;
    }

    .ddk-container .hero-info .hero-description {
        font-family: ${props => props.theme.font_family ?? 'Inter'};
        color: ${props =>
            props.theme.hero_subtitle_text ?? 'var(--ddk-text-base-primary)'};
        font-size: ${props =>
            props.theme.hero_subtitle_font_size ?? 'var(--ddk-font-size-md)'};
        font-style: normal;
        font-weight: 400;
    }

    .ddk-container .hero-tags {
        display: flex;
        align-items: flex-start;
        align-content: flex-start;
        gap: 16px var(--ddk-spacing-space-3, 24px);
        flex: 1 0 0;
        flex-wrap: wrap;
        font-size: ${props =>
            props.theme.tag_font_size ?? 'var(--ddk-font-size-sm, 14px)'};
    }

    .ddk-container .hero-content .hero-logo-container {
        display: flex;
        justify-content: center;
        min-width: 210px;
        max-width: 210px;
        max-height: 120px;
    }

    .ddk-container .hero-content .hero-logo-container img {
        max-width: 100%;
        max-height: 120px;
        height: auto;
    }

    .ddk-container .more-tags-wrapper {
        display: flex;
        flex-direction: column;
    }

    .ddk-container .more-tags {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        gap: var(--ddk-grid-2, 16px);
        align-self: stretch;
        overflow: hidden;
    }

    .ddk-container .hero-stack .more-tags-drawer {
        display: grid;
        grid-template-rows: 0fr;
        transition: grid-template-rows 0.6s ease;
    }

    .ddk-container .hero-stack .more-tags-drawer.open {
        grid-template-rows: 1fr;
    }

    .ddk-container .hero-stack .more-tags-button {
        display: flex;
        height: var(--ddk-grid-4, 32px);
        padding: var(--ddk-padding-2xs, 4px) var(--ddk-padding-xs, 8px);
        align-items: center;
        gap: var(--ddk-grid-half, 4px);
        border: none;
        background: none;
        color: ${props => props.theme.accent};
        font-family: ${props => props.theme.font_family ?? 'Inter'};
        font-size: var(--ddk-font-size-sm);
        font-style: normal;
        font-weight: var(--ddk-font-normal);
        line-height: 150%;
        letter-spacing: 0.014px;
        transition: all 0.3s ease;
    }

    .ddk-container .hero-stack .more-tags-button:hover {
        color: ${props => getSimilarColor(props.theme.accent, 'darken', 20)};
    }

    .ddk-container .hero-content .hero-stack .hero-button-container {
        max-width: 400px;
        min-width: 120px;
    }

    /* Media queries and CSS for mobile devices */

    @media screen and (max-width: 480px) {
        .ddk-container .hero-content .hero-logo-container {
            max-height: 100px;
            max-width: 100px;
        }

        .ddk-container .layout-hero-container .hero-content .hero-stack {
            flex-direction: column;
            row-gap: var(--ddk-grid-3);
        }
        .ddk-container .hero-content .hero-stack .hero-button-container {
            width: 100%;
        }
    }
`;

export default styles;
